import { createFileRoute } from '@tanstack/react-router';
import UsersPage from '@/pages/setup/UsersPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export const Route = createFileRoute('/_authenticated/setup/users')({
  beforeLoad: () => requireSetupPageAccess('/setup/users'),
  component: UsersPage,
});
